import React from "react";

export const useAudio = (localRef, handleLogs) => {
  const [isAudioOn, setIsAudioOn] = React.useState(true);

  /**
   * Toggles the local audio track on/off.
   */
  const toggleAudio = React.useCallback(() => {
    if (localRef.current && localRef.current.srcObject) {
      const audioTrack = localRef.current.srcObject.getAudioTracks()[0];
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled;
        setIsAudioOn(audioTrack.enabled);
        handleLogs(`Audio ${audioTrack.enabled ? "unmuted" : "muted"}`);
      }
    }
  }, [localRef, handleLogs, setIsAudioOn]);
  return { toggleAudio, isAudioOn, setIsAudioOn };
};
